import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { InferRequestType, InferResponseType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type DeleteUserRequest = InferRequestType<
  (typeof apiClient.users)[':userId']['$delete']
>['param']
type DeleteUserResponse = InferResponseType<
  (typeof apiClient.users)[':userId']['$delete']
>

export const useDeleteUser = (
  options?: UseMutationOptions<DeleteUserResponse, Error, DeleteUserRequest>
) =>
  useMutation({
    mutationFn: async (variables) => {
      return await apiClient.users[':userId']
        .$delete({ param: variables })
        .then((r) => formatClientResponse(r))
    },
    mutationKey: ['delete-user'],
    ...options,
  })
